import React from 'react';
import PropTypes from 'prop-types';
import Videos from '../components/Videos';
import Details from '../components/Details';
import Images from '../components/Images';
import Text from '../components/ui/Text';
import Copy from '../components/ui/Copy';

function Page(props) {
  const { page } = props;
  return (
    page && (
      <div className="">
        <div className="">{page.title && <h1>{page.title}</h1>}</div>
        {page.images && (
          <Images
            showList={page.showList}
            showLarge={!page.sublinks}
            selectedImage={page.images[0]}
            images={page.images}
            getPath={props.getPath}
            parent={props.parent}
            getImage={props.getImage}
          />
        )}
        {page.videos && (
          <Videos selectedVideo={page.videos[0]} videos={page.videos} />
        )}
        {page.intro && (
          <div className="box-text">
            <Text text={page.intro} useParser={page.useParser} />
          </div>
        )}
        {page.specs && (
          <div className="margin-top">
            <Text text={page.specs} />
          </div>
        )}
        {page.content && <Details data={page.content} />}
        {page.info && <Text className="margin-top" text={page.info} />}
        {page.copy && <Copy className="margin-top--big" text={page.copy} />}
      </div>
    )
  );
}

Page.propTypes = {
  page: PropTypes.object,
  getImage: PropTypes.func.isRequired,
  getPath: PropTypes.func.isRequired,
  parent: PropTypes.shape({})
};

export default Page;



// WEBPACK FOOTER //
// ./src/pages/Page.jsx